/**
 * @description initialize each class defined in /classes.
 * @requires /classes/backtop.class.js
 * @requires /classes/dnneditor.class.js
 * @requires /classes/footer.class.js
 * @requires /classes/header.class.js
 * @requires /classes/helpers.class.js (static)
 * @requires /classes/menu.class.js
 * @requires /classes/notificationbanner.class.js
 * @requires /classes/phonenumber.class.js
 * @requires /classes/plugin-loader.class.js
 */

const debug = false;   // true: show debug messages, false: don't show debug messages

document.addEventListener('DOMContentLoaded', () => {

  //injectCoreMinCss();

  setTimeout( () => {
    if (debug) console.log('TRITON COMMERCE DEBUG LOG');
    const pluginLoader = new PluginLoader(debug);
    const phoneNumber = new PhoneNumber(debug);
    const backTop = new BackTop(debug);
    const dnneditor = new DNNEditor(debug);
    const header = new Header(debug);
    //const footer = new Footer(debug);
    const menu = new Menu(debug);
    const notificationBanner = new NotificationBanner(debug);
  }, 100);

});

/**
 * Injects core.min.css after the DOMContentLoaded event.
 */
function injectCoreMinCss() {
  let coreMinJs = document.querySelector('script[src*="core.min.js"]');
  let coreMinJsSrc = coreMinJs.getAttribute('src');
  let distPath= coreMinJsSrc.substring(0, coreMinJsSrc.indexOf('/js'), coreMinJsSrc.length);
  let coreMinCssSrc = distPath + '/css/core.min.css';

  let elHead = document.querySelector('head');
  let elCoreMinCss = document.createElement('link');
  elCoreMinCss.setAttribute('rel', 'stylesheet');
  elCoreMinCss.setAttribute('type', 'text/css');
  elCoreMinCss.setAttribute('href', coreMinCssSrc);

  elHead.appendChild(elCoreMinCss);
  document.body.style.marginTop = 0;

  console.log(elHead);
}